import { SingService } from "app/components/service/sing.service";
import { Injectable, ElementRef } from "@angular/core";
import { SummExpense } from "../class/summ-expense";
import { Expense } from "app/components/class/expense/expense";
import { TableData } from "app/components/class/table-data";
import { IndexExpense } from "app/components/class/index-expense";
import { Broadcaster } from "app/components/service/Broadcaster";
import { Alert } from "app/components/class/alert/alert";
import { FlightDateSave } from "app/components/class/expense/flight-date-save";
import { ChangeSumm } from "../class/ChangeSumm";
import { responseUpdateExpensesProduct } from "app/components/class/http/res/response-update-expenses-product";
import { responseRemoveExpense } from "app/components/class/http/res/response-remove-expense";
import { showAddCampaignMode } from "app/components/class/broadcaster/add-campaign/show-add-campaign-mode";
import { updateCategories } from "app/components/class/broadcaster/update-categories";
import { Stats } from "app/components/class/stats/stats";
import { updateData } from "app/components/class/broadcaster/updateData";
import { updateInfoItem } from "app/components/class/broadcaster/update-info-item";
import { updateCategoriesAfterRemoveExpense } from "app/components/class/broadcaster/add-campaign/update-categories-after-remove-expense";
import { AddCampaignInit } from "app/components/class/broadcaster/add-campaign/add-campaign-init";
import { ExpenseForAdd } from "app/components/interfaces/expense-for-add";

@Injectable()
export class AddCampaign {
    defaultData: showAddCampaignMode;
    indexExpense: number = 0;
    indexProduct: number = 0;
    productCategoryId: string;
    UpdateListProducts: boolean = false;
    productId: string;
    dataId: IndexExpense;
    tableData: TableData = new TableData();
   
    
    constructor(private httpService: SingService, private elRef: ElementRef, private broadcaster: Broadcaster) { }
    public getFlightDate(settings: any, targetBudget: number): Array<FlightDateSave> {
        let countDays = 32 - new Date(settings.year, settings.month - 1, 32).getDate();
        return [new FlightDateSave({
            start: `${settings.year}-${(settings.month < 10) ? "0" + settings.month : settings.month}-01`,
            end: `${settings.year}-${(settings.month < 10) ? "0" + settings.month : settings.month}-${(countDays < 10) ? "0" + countDays : countDays}`,
            targetBudget: targetBudget
        })
        ];

    }
    ClosedErrorAlert() {
        this.elRef.nativeElement.querySelector(".mask-error").style.display = "none";
        this.elRef.nativeElement.querySelector(".error-alert").style.display = "none";
    }
    public show() {
        this.elRef.nativeElement.querySelector(".modal-add-product").classList.add("m--fade");
        this.elRef.nativeElement.querySelector(".modal-add-product").style.display = "block";
        (<HTMLElement>document.body.querySelector(".allwhite")).style.display = "block";
        document.body.querySelector("main").classList.add("m--blur");
    }
    public setSummExpense(data: SummExpense) {
        return this.httpService.setSummExpense(data);
    }
    public summBudgets(list: any): number {
        let out: number = 0;
        for (let i = 0; i < list.length; i++) {
            out += list[i].budget;
        }
        return out;
    }
    public summTargetBudgets(list: Array<Expense>): number {
        let out: number = 0;
        for (let i = 0; i < list.length; i++) {
            out += list[i].targetBudget;
        }
        return out;
    }
    public summPrice(list: any): number {
        let out: number = 0;
        for (let i = 0; i < list.length; i++) {
            out += list[i].price;
        }
        return out;
    }
    public checkExpensesAfterRemove(expenses:Array<Expense>,changeSumm:ChangeSumm,PlannedBudget:number) {
        let errorCampaign: boolean = false;
        let targetBudgetPercent: number = 0;
        let targetBudget: number = 0;
        let actualBudgetPercent: number = 0;

        let countId:number = 0;
       
       
        
        for (let i = 0; i < expenses.length; i++) {
            if (expenses[i].id > 0) {
                countId++;
            }

            targetBudgetPercent += Number(expenses[i].targetBudgetPercent);
            actualBudgetPercent += Number(expenses[i].actualBudgetPercent);
            targetBudget += expenses[i].targetBudget;
            if (expenses[i].campaign === "") {
                errorCampaign = true;
            }
            if (targetBudgetPercent >= 100 && (i + 1) !== expenses.length) {
               
                return true;
            }
            for (let u = (i + 1); u < expenses.length; u++) {
                if (expenses[i].campaign === expenses[u].campaign) {
                 
                    return true;
                }

            }
        }
        if (targetBudget !== PlannedBudget) {
         
            return true;
        }
        if (targetBudgetPercent !== 100) {
         
            return true;
        }
        if (errorCampaign) {
           
            return true;
        }

        if (changeSumm) {
            if (actualBudgetPercent === 0) {
                actualBudgetPercent = 100;
            }
            if (actualBudgetPercent !== 100) {
               
                return true;
            }
        }
        if (countId === 0) {
            return true;
        }
        return false;
    }
    public getCOOPSum (list: Array<Expense>): number {
        let out: number = 0;
        for (let i = 0; i < list.length; i++) {
            out += list[i].coop;
        }
        return out;
    }
    public summActualBudget(list: Array<Expense>): number {
        let out: number = 0;
        for (let i = 0; i < list.length; i++) {
            out += list[i].actualBudget;
        }
        return out;
    }
    public CloseAll() {
        this.elRef.nativeElement.querySelector(".modal-add-product").classList.remove("m--fade");
        this.elRef.nativeElement.querySelector(".modal-add-product").style.display = "none";
        document.body.querySelector("main").classList.remove("m--blur");
        (<HTMLElement>document.body.querySelector(".allwhite")).style.display = "none";

    }
    public checkInt(number): boolean {
        if (parseInt(number) != number) {
            return false;
        }
        return true;
    }
    public ceil(num:number):number {
return Math.ceil((num)*100)/100;
    }
    public round(number): number {
       return Math.ceil((number)*10)/10;
    }
    public getExpense(id) {
        return this.httpService.getExpense(id);
    }
    public AfterUpdateSummExpenses(data: responseUpdateExpensesProduct, changeSumm: ChangeSumm) {
        let indexProduct: number = data.category.products.findIndex(item => String(item.id) === String(changeSumm.product.id).split("products-").join(""));
        changeSumm.categori[this.dataId.i].price = data.category.price;

        changeSumm.categori[this.dataId.i].products[this.dataId.u].price = data.category.products[indexProduct].price;
        for (let u = 0; u < changeSumm.categori[this.dataId.i].products[this.dataId.u].subproducts.length; u++) {

            changeSumm.categori[this.dataId.i].products[this.dataId.u].subproducts[u].price = data.category.products[indexProduct].subproducts[u].price;
            changeSumm.categori[this.dataId.i].products[this.dataId.u].subproducts[u].expenses[0].price = data.category.products[indexProduct].subproducts[u].expenses[0].price;
        }

        this.broadcaster.broadcast("updateCategories", new updateCategories(changeSumm.categori));

        this.broadcaster.broadcast("updateData", new updateData(data.stats));
        this.broadcaster.broadcast("updateInfoItem", new updateInfoItem({
            id: null,
        }));
    }
    public AfterremoveExpense(dataId: IndexExpense, res: responseRemoveExpense) {
        this.broadcaster.broadcast("updateCategoriesAfterRemoveExpense", new updateCategoriesAfterRemoveExpense(dataId,res));

        this.broadcaster.broadcast("updateData", new updateData(res.stats));
        this.broadcaster.broadcast("UpdateListProducts", null);
    }
  

    public getExpenseForUpdate(expense: Expense): Expense {
        let out_expense: Expense = new Expense();
        out_expense.id = expense.id,
            out_expense.targetBudget = expense.targetBudget,
            out_expense.actualBudget = expense.actualBudget,
            out_expense.campaign = expense.campaign,
            out_expense.strategy = expense.strategy,
            out_expense.description = expense.description,
            out_expense.notes = expense.notes,
            out_expense.coop = expense.coop,
            out_expense.creativeId = expense.creativeId

        return out_expense;
    }
    public showErrorAlert(messageError: string) {
        this.broadcaster.broadcast("showAlert", new Alert(messageError, true));
        return;

    }
    public compliteSaveExpense(dataId: IndexExpense) {
        this.broadcaster.broadcast("AddCampaign", new AddCampaignInit(dataId,this.UpdateListProducts));
        this.broadcaster.broadcast("setstats", null);
        this.broadcaster.broadcast("updateBudget", null)
    }
    public getExpenseForAdd(expense: Expense, tableData: TableData): ExpenseForAdd {
        let out_expense: ExpenseForAdd = {
        dealerShipId : tableData.settings.dealerShipId,
        month : tableData.settings.month,
        year : tableData.settings.year,
        productId : expense.productId,
        productCategoryId : expense.productCategoryId,
        targetBudget : expense.targetBudget,
        actualBudget : expense.actualBudget,
        flightDate : this.getFlightDate(tableData.settings, expense.targetBudget),
        campaign : expense.campaign,
        strategy : "",
        description : "",
        notes : "",
        coop : expense.coop,
        creativeId : "",
        }
        return out_expense;
    }
    public addExpense(data: ExpenseForAdd) {
        return this.httpService.addExpense(data);
    }
    public removeExpense(id:number) {
        return this.httpService.removeExpense(id, false);
    }
    public saveExpense(data: Expense) {
        return this.httpService.saveExpense(data);
    }
}


// WEBPACK FOOTER //
// ./src/app/components/add-campaign/service/add-campaign.service.ts